import { get, post, patch, del } from './client.js';

export const list = () => get('/orgs');
export const getOne = (orgId) => get(`/orgs/${orgId}`);
export const create = (body) => post('/orgs', body);
export const update = (orgId, body) => patch(`/orgs/${orgId}`, body);
export const suspend = (orgId) => post(`/orgs/${orgId}/suspend`);
export const activate = (orgId) => post(`/orgs/${orgId}/activate`);
export const remove = (orgId) => del(`/orgs/${orgId}`);

/* Members */
export const listMembers = (orgId) => get(`/orgs/${orgId}/members`);
export const inviteMember = (orgId, body) => post(`/orgs/${orgId}/members/invite`, body);
export const updateMember  = (orgId, memberId, body) => patch(`/orgs/${orgId}/members/${memberId}`, body);
export const suspendMember = (orgId, memberId) => post(`/orgs/${orgId}/members/${memberId}/suspend`);
export const activateMember = (orgId, memberId) => post(`/orgs/${orgId}/members/${memberId}/activate`);
export const removeMember = (orgId, memberId) => del(`/orgs/${orgId}/members/${memberId}`);

/* Workspaces under org */
export const listWorkspaces = (orgId, params) => {
  const q = params
    ? '?' + new URLSearchParams(Object.entries(params).filter(([, v]) => v != null).map(([k, v]) => [k, String(v)])).toString()
    : '';
  return get(`/orgs/${orgId}/workspaces${q}`);
};
export const createWorkspace  = (orgId, body)    => post(`/orgs/${orgId}/workspaces`, body);
export const updateWorkspace  = (orgId, wsId, body) => patch(`/orgs/${orgId}/workspaces/${wsId}`, body);
export const archiveWorkspace  = (orgId, wsId)    => post(`/orgs/${orgId}/workspaces/${wsId}/archive`);
export const restoreWorkspace  = (orgId, wsId)    => post(`/orgs/${orgId}/workspaces/${wsId}/restore`);
export const deleteWorkspace   = (orgId, wsId)    => del(`/orgs/${orgId}/workspaces/${wsId}`);

/* Atomic org provisioning — single transaction (org + subscription + licenses + quotas) */
export const provisionOrg = (body) => post('/platform/orgs/provision', body);

/* Provision org admin (SA only) */
export const provisionAdmin = (orgId, body) => post(`/platform/orgs/${orgId}/provision-admin`, body);

/* Archive org (SA only) */
export const archive = (orgId) => post(`/orgs/${orgId}/archive`);

/* Restore archived org to SUSPENDED state (SA only) */
export const restore = (orgId) => post(`/orgs/${orgId}/restore`);

/* Member sessions */
export const getMemberSessions = (orgId, memberId) => get(`/orgs/${orgId}/members/${memberId}/sessions`);

/* Settings */
export const getSettings = (orgId) => get(`/orgs/${orgId}/settings`);
export const updateSmtp = (orgId, body) => patch(`/orgs/${orgId}/settings/smtp`, body);
export const testSmtp = (orgId) => post(`/orgs/${orgId}/settings/smtp/test`, {});
export const updateLocalization = (orgId, body) => patch(`/orgs/${orgId}/settings/localization`, body);
export const updatePreferences = (orgId, body) => patch(`/orgs/${orgId}/settings/preferences`, body);
export const getBackupHistory = (orgId) => get(`/orgs/${orgId}/settings/backup/history`);
export const updateBackup = (orgId, body) => patch(`/orgs/${orgId}/settings/backup`, body);
export const triggerBackup = (orgId) => post(`/orgs/${orgId}/settings/backup/trigger`, {});
export const requestRestore = (orgId) => post(`/orgs/${orgId}/settings/backup/restore`, {});

/* Policies */
export const getPolicies = (orgId) => get(`/orgs/${orgId}/policies`);
export const updatePolicies = (orgId, body) => patch(`/orgs/${orgId}/policies`, body);
